import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

interface ConfigErrorProps {
  onRetry?: () => void;
}

const ConfigError: React.FC<ConfigErrorProps> = ({ onRetry }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-lg w-full p-8">
        <div className="flex items-center justify-center mb-6">
          <div className="bg-red-100 p-4 rounded-full">
            <AlertCircle className="text-red-600" size={48} />
          </div>
        </div>
        
        <h1 className="text-2xl font-bold text-center text-gray-900 mb-2">
          Configuration Required
        </h1>
        <p className="text-gray-600 text-center mb-6">
          The application needs to be configured with Supabase credentials.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <h3 className="font-medium text-gray-700 mb-2">Steps to fix:</h3>
          <ol className="list-decimal list-inside space-y-2 text-sm text-gray-600">
            <li>
              Create a <code className="bg-gray-200 px-2 py-0.5 rounded">.env</code> file in your project root
            </li>
            <li>
              Add your Supabase credentials:
              <div className="bg-gray-800 text-green-400 p-3 rounded-lg mt-2 font-mono text-xs overflow-x-auto">
                REACT_APP_SUPABASE_URL=your_supabase_url<br />
                REACT_APP_SUPABASE_ANON_KEY=your_supabase_anon_key
              </div>
            </li>
            <li className="mt-2">
              Get credentials from: <br />
              <span className="text-blue-600">Supabase Dashboard → Settings → API</span>
            </li>
            <li>
              Restart your development server
            </li>
          </ol>
        </div>

        {onRetry && (
          <button
            onClick={onRetry}
            className="w-full btn-primary flex items-center justify-center gap-2 py-2.5"
          >
            <RefreshCw size={18} />
            Retry Connection
          </button>
        )}
      </div>
    </div>
  );
};

export default ConfigError;